import { toasterMsg } from "../../../../../Components/Toaster/Toaster";
import t from "./Purchase.type";
import { getSeasons, getSupplier, getUserSuppliers } from "../../../../../services/supplierSuggestion.service";
import { getAllBrands, getAllCategory } from "../../../../../services/supplier.service";
import { getAllUsers, getSampleRequestsTodoListService, getTodolistCountService, exportExcelService, exportToPdfService } from "../../../../../services/todo-list.service";
import { getMainSamples, getOtherSamples, getSampleTraking } from "../../../../../services/sample.service";
import { getAllSampleStatus } from "../../../../../services/SystemMaster.services";
import { apiClient, apiEndpoint } from "../../../../../services/api.services";
import { API } from "../../../../../constants/api.constants";
import { imageUrl } from "../../../../../Components/helper";

export const getSeasonsAction = (id) => async () => {
  try {
    const res = await getSeasons(id);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const saveShippedDate = async (params) => {
  try {
    const res = await apiClient.post(`${apiEndpoint}${API.PURCHASE_ORDER.SAVE_SHIPPED_DATE}`, {
      ...params,
    });
    if (res.code === 200) {
      toasterMsg(res.message.toString(), 'success');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCreatedByUser = (pramams) => async (dispatch) => {
  try {
    const res = await getAllUsers(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_CREATED_BY_USER,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getPurchaseList = (pramams) => async (dispatch) => {
  try {
    const res = await getSampleRequestsTodoListService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PURCHASE_REQUESTS_TODOLIST,
        payload: {
          data: res.data.doc,
          totalCount: res.data.totalCount,
          searchText: pramams.searchText,
          isScrolled: pramams.isScrolled,
        },
      });
      return res.data.doc;
    }
    return res?.data;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllBrandAction = (params) => async () => {
  try {
    const res = await getAllBrands(params);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSuppliers = (data) => async () => {
  try {
    const res = await getSupplier(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchUserSuppliersAction = () => async () => {
  try {
    const res = await getUserSuppliers();
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getMainSamplesAction = (pramams) => async (dispatch) => {
  try {
    const res = await getMainSamples(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_MAIN_SAMPLES,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSampleStatus = (params) => async () => {
  try {
    const res = await getAllSampleStatus(params);
    return res.data;
  } catch (error) {
    toasterMsg(error.message, 'danger');
  }
};

export const fetchCategoryAction = (params) => async (dispatch) => {
  const setValueObj = (label, value) => {
    return { label, value };
  };
  try {
    const res = await getAllCategory(params);
    if (res.code === 200 && res.data) {
      const category = await res.data.map((item) => {
        return setValueObj(item.label, item.value);
      });
      await dispatch({
        type: t.CATEGORY,
        payload: category,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getOtherSamplesAction = (pramams) => async (dispatch) => {
  try {
    const res = await getOtherSamples(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_OTHER_SAMPLES,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSampleTrakingAction = () => async () => {
  try {
    const res = await getSampleTraking();
    if (res?.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const getPurchaseTodolistCount = (pramams) => async (dispatch) => {
  try {
    const res = await getTodolistCountService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PURCHASE_TODO_LIST_COUNT,
        payload: {
          totalCount: res.data.totalCount,
          type: pramams.type,
        },
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const setPurchaseSelectedIds = (idsArr) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_SELECTED_IDS_ARRAY,
      payload: idsArr,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const exportExcel = (params) => async () => {
  try {
    const res = await exportExcelService(params);
    if (res?.data?.fileName) {
      const fileName = res.data.fileName.toString();
      const fileUrl = res.data.zipUrl?.startsWith("http") ? res.data.zipUrl : `${imageUrl}/${res.data.zipUrl}`;

      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const fileObjectURL = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = fileObjectURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileObjectURL);
        })
        .catch((error) => console.error("Download error:", error));
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const exportToPdf = (params) => async () => {
  try {
    const res = await exportToPdfService(params);
    if (res?.data?.fileName) {
      const fileName = res.data.fileName.toString();
      const fileUrl = res.data.zipUrl?.startsWith("http") ? res.data.zipUrl : `${imageUrl}/${res.data.zipUrl}`;

      fetch(fileUrl)
        .then((response) => response.blob()) // Convert response to a Blob
        .then((blob) => {
          const fileObjectURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = fileObjectURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileObjectURL); // Cleanup
        })
        .catch((error) => console.error('Download error:', error));
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
